var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "text-center mx-auto w-full flex flex-col items-center",
      attrs: { autocomplete: "off", method: "post", action: "" }
    },
    [
      _c("input", {
        staticStyle: { display: "none" },
        attrs: { autocomplete: "false", name: "hidden", type: "text" }
      }),
      _vm._v(" "),
      _vm._l(
        _vm.$store.state.data.Steps[_vm.$store.state.activeStep].Form,
        function(input) {
          return _c("vpf-input", {
            key: input.Id,
            ref: "autocompleteInput",
            refInFor: true,
            attrs: {
              autocomplete: "false",
              type: "address",
              id: "autocomplete",
              name: input.Name,
              placeholder: input.Placeholder,
              "is-required": input.Required,
              label: input.Label,
              "is-value-from-list": _vm.isSelectedFromList,
              "error-message": input.ErrorMessage,
              value: _vm.$store.state.addressText,
              wide: true
            },
            on: {
              inputWasChanged: function($event) {
                return _vm.setValidity($event)
              },
              input: function($event) {
                return _vm.resetValidation()
              }
            }
          })
        }
      ),
      _vm._v(" "),
      _c(
        "vpf-button",
        {
          staticClass: "md:mt-6",
          attrs: {
            "is-disabled": !_vm.isSelectedFromList && _vm.form.isInvalid
          },
          nativeOn: {
            click: function($event) {
              return _vm.setNextStep()
            }
          }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$store.state.data.Steps[_vm.$store.state.activeStep]
                  .ButtonTextNext
              ) +
              "\n  "
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }